module.exports = __webpack_public_path__ + "static/media/200009_actoren.c0f67aa1.jpg";